import Head from "next/head";
// import {generateTitle} from "../helpers/meta";
// import {useRouter} from "next/router";
// import localized from "../locale/locales";
import Embed from "../../components/Embed";

export default function Register() {
    // const {locale} = useRouter();
    // const {register: lang} = localized[locale];

    return (
        <>
            <Head>
                <title key="title">Work Travel Holandsko – Vycestuj do Holandska a zaži najlepší rok svojho
                    života!</title>
                <meta key="og:title" property="og:title"
                      content="Work Travel Holandsko – Vycestuj do Holandska a zaži najlepší rok svojho života!"/>
                {/*<title key="title">{generateTitle(lang.og.title)}</title>*/}
                {/*<meta key="og:title" property="og:title" content={generateTitle(lang.og.title)}/>*/}
            </Head>

            <Embed url="https://work-travel-holandsko.eu/sk/"/>
        </>
    )
}
